const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/** Selector de enlaces que abren el cart drawer (Dawn + header 1925 + flotante PDP). */
const CART_DRAWER_TRIGGER_SELECTORS =
  'a.header-1925__cart-link, a.header-1925-floating-cart, a.header-1925-floating-trigger--cart, a.pdp-cart-floating, a#cart-icon-bubble-mobile, a#cart-icon-bubble, a#cart-icon-bubble-desktop';

function is1925MobileCartViewport() {
  return window.matchMedia('(max-width: 989px)').matches;
}

function getActive1925CartCountElement() {
  if (is1925MobileCartViewport()) {
    return document.getElementById('cart-icon-bubble-mobile') || document.getElementById('cart-icon-bubble');
  }
  return document.getElementById('cart-icon-bubble-desktop');
}

function is1925CartCountElement(element) {
  return (
    element &&
    (element.classList.contains('header-1925__cart-count') ||
      element.classList.contains('header-1925-floating-cart__count') ||
      element.classList.contains('pdp-cart-counter'))
  );
}

function getCartIconBubbleRenderTarget() {
  const bubble = getActive1925CartCountElement() || document.getElementById('cart-icon-bubble');

  if (is1925CartCountElement(bubble)) {
    return {
      id: 'cart-icon-bubble-1925',
      section: 'cart-icon-bubble-1925',
      selector: null,
      domId: bubble.id,
    };
  }

  return {
    id: 'cart-icon-bubble',
    section: 'cart-icon-bubble',
    selector: '.shopify-section',
    domId: 'cart-icon-bubble',
  };
}

if (typeof window !== 'undefined') {
  window.getCartIconBubbleRenderTarget = getCartIconBubbleRenderTarget;
  window.getActive1925CartCountElement = getActive1925CartCountElement;
  window.sync1925CartCountBubbles = sync1925CartCountBubbles;
  window.sync1925FloatingCartVisibility = sync1925FloatingCartVisibility;

  document.addEventListener('DOMContentLoaded', () => {
    const countEl =
      document.getElementById('cart-icon-bubble-mobile') ||
      document.getElementById('cart-icon-bubble') ||
      document.getElementById('cart-icon-bubble-desktop');
    if (countEl) sync1925FloatingCartVisibility(countEl.textContent);
  });
}

function sync1925FloatingCartVisibility(countText) {
  const text = countText == null ? '' : String(countText).trim();
  const count = parseInt(text, 10);
  const show = !isNaN(count) && count >= 1;

  document.querySelectorAll('[data-header-1925-floating-cart]').forEach((el) => {
    el.classList.toggle('header-1925-floating-cart--hidden', !show);
    el.setAttribute('aria-hidden', show ? 'false' : 'true');
  });
}

function sync1925CartCountBubbles(countText) {
  const text = countText == null ? '' : String(countText).trim();
  document.querySelectorAll('.header-1925__cart-count, .header-1925-floating-cart__count, .pdp-cart-counter, #CartCounterBubble').forEach((el) => {
    el.textContent = text;
    const count = parseInt(text, 10);
    if (!isNaN(count) && count >= 10) {
      el.setAttribute('data-cart-wide', '');
    } else {
      el.removeAttribute('data-cart-wide');
    }
  });
  sync1925FloatingCartVisibility(text);
}
